// extracted by mini-css-extract-plugin
export default {"SidebarItemWrapper":"Item_SidebarItemWrapper__wuYbC","active":"Item_active__BazX2"};